import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=5430b214&scoped=true"
var script = {}
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=5430b214&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5430b214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5430b214')) {
      api.createRecord('5430b214', component.options)
    } else {
      api.reload('5430b214', component.options)
    }
    module.hot.accept("./ErrorIcon.vue?vue&type=template&id=5430b214&scoped=true", function () {
      api.rerender('5430b214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ErrorIcon.vue"
export default component.exports